import React from "react";

import LineChart from "../../../AnalysisCollectionsComponents/CollectionChartArea/LineChart";
import { Timespan } from "../../../DataDownloadComponents/TimespanPicker/types";
import { FacilityDetailsAnalysisControls } from "../Controls";
import { useIndividualFacilityChart } from "../hooks/useIndividualFacilityChart";
import { useIndividualFacilityChartDetails } from "../hooks/useIndividualFacilityChartDetails";
import { IFacilityDetailsAnalysisChartOptions } from "../types";

export interface IFacilityDetailsAnalysisChartProps {
  locationId: string;
  timespan: Timespan;
  selectedChartId: number | undefined;
  options: IFacilityDetailsAnalysisChartOptions;
  setOptions: React.Dispatch<
    React.SetStateAction<IFacilityDetailsAnalysisChartOptions>
  >;
}

export const FacilityDetailsAnalysisChart: React.FunctionComponent<
  IFacilityDetailsAnalysisChartProps
> = (props) => {
  const { locationId, selectedChartId, options, setOptions, timespan } = props;

  const { data: chartData } = useIndividualFacilityChart(selectedChartId);
  const { currentData, prevYearData, isFetching } =
    useIndividualFacilityChartDetails({
      locationId,
      chartData,
      timespan,
      options,
    });

  const handleSetTimeUnit = (unit: "day" | "week" | "month") => {
    setOptions((o) => ({ ...o, fidelity: unit }));
  };

  const handleSetUsePrevYear = (shouldUse: boolean) => {
    setOptions((o) => ({ ...o, compareToPrev: shouldUse }));
  };

  return (
    <div className="facility-details-analysis-chart">
      <FacilityDetailsAnalysisControls
        chartData={chartData}
        chartDetails={currentData}
        prevYearChartDetails={prevYearData}
        compareToPrev={options.compareToPrev}
        timeUnit={options.fidelity}
      />
      <LineChart
        chartDetailsData={isFetching ? undefined : currentData}
        prevYearChartDetailsData={isFetching ? undefined : prevYearData}
        usePrevYear={options.compareToPrev}
        timeUnit={options.fidelity}
        skipLabelTranslation={false}
        setTimeUnit={handleSetTimeUnit}
        setUsePrevYear={handleSetUsePrevYear}
      />
    </div>
  );
};
